const dummyData = {
  'cold-knowledge': [
    {
      id: 'ck1',
      title: '为什么猫跳下高楼比狗更容易存活？',
      brief: '猫有天生的"翻正反射"和特殊的身体结构。',
      details: '猫在下落时能够调整身体姿态，确保四肢先着地，并且它们的身体相对轻盈，骨骼柔韧，有助于分散冲击力。狗则没有这种空中调整能力，且体重通常更大。',
      tags: ['动物', '科学', '物理']
    },
    {
      id: 'ck2',
      title: '耳屎其实是一种天然抗菌剂？',
      brief: '是的，耳屎能保护耳朵。',
      details: '耳屎（耵聍）含有溶解酶，可以破坏细菌的细胞壁，同时其微酸性和疏水性也能抑制细菌和真菌生长，保护外耳道。',
      tags: ['人体', '健康', '科学']
    },
    {
      id: 'ck3',
      title: '香蕉是弯的，因为它们向着太阳生长。',
      brief: '这叫做"负向地性生长"。',
      details: '香蕉最初是向下生长的，但为了获得更多阳光，它们会转而向上生长，对抗地心引力，从而形成了弯曲的形状。',
      tags: ['植物', '科学']
    },
    {
      id: 'ck4',
      title: '北极熊的皮肤其实是黑色的。',
      brief: '它们的毛发是透明中空的，看起来是白色。',
      details: '北极熊的毛发是透明且中空的，能够散射光线，使其看起来是白色的，这有助于它们在雪地中伪装。它们皮肤是黑色的，这有助于吸收阳光保暖。',
      tags: ['动物', '科学', '极地']
    },
    {
      id: 'ck5',
      title: '章鱼有三个心脏。',
      brief: '两个负责鳃的血液循环，一个负责身体其他部分。',
      details: '章鱼的两个鳃心脏将血液泵过鳃部进行氧合，而体心脏则将含氧血液泵送到身体的其他部位。当章鱼游泳时，体心脏会停止跳动，这解释了为什么它们更喜欢爬行而不是长时间游泳。',
      tags: ['动物', '海洋生物', '科学']
    },
    {
      id: 'ck6',
      title: '"牛油果"这个词来源于阿兹特克语，意思是"睾丸"。',
      brief: '因其形状和成对悬挂的方式而得名。',
      details: '阿兹特克人称牛油果为"āhuacatl"，这个词也用来指代睾丸，可能是因为牛油果通常成对生长在树上，并且形状相似。',
      tags: ['语言', '历史', '植物', '文化']
    },
    {
      id: 'ck7',
      title: '世界上最常见的鸟是鸡。',
      brief: '家养鸡的数量远超任何野生鸟类。',
      details: '由于人类的养殖，家鸡的数量估计超过250亿只，是地球上数量最多的鸟类，也可能是数量最多的脊椎动物。',
      tags: ['动物', '鸟类', '统计']
    },
    {
      id: 'ck8',
      title: '打火机比火柴发明得早。',
      brief: '第一个打火机在19世纪初就出现了。',
      details: '德国化学家约翰·沃尔夫冈·德贝莱纳于1823年发明了第一个打火机，称为"德贝莱纳灯"。而摩擦火柴则是在1826年由英国药剂师约翰·沃克发明的。',
      tags: ['发明', '历史', '科技']
    },
    {
      id: 'ck9',
      title: '人的鼻子和耳朵一生都在不停地生长。',
      brief: '这主要是因为软骨的持续生长和重力作用。',
      details: '虽然骨骼在青春期后停止生长，但构成鼻子和耳朵的软骨会随着年龄的增长而缓慢地继续生长。此外，皮肤弹性的丧失和重力作用也会使它们看起来更大更长。',
      tags: ['人体', '科学', '衰老']
    },
    {
      id: 'ck10',
      title: '"SPAM"午餐肉的名字来源于"Spiced Ham"（五香火腿）。',
      brief: '这是一个缩写词。',
      details: 'SPAM这个名字是由 Hormel Foods 公司在1937年通过一场命名竞赛选出的，普遍认为它代表"Spiced Ham"。尽管也有其他说法，如"Shoulder of Pork And Ham"。',
      tags: ['食物', '品牌', '语言']
    },
    {
      id: 'ck11',
      title: '苏格兰的国兽是独角兽。',
      brief: '独角兽象征纯洁、天真和力量。',
      details: '独角兽自15世纪以来就是苏格兰的官方象征之一，常出现在苏格兰的纹章和钱币上。它被选为国兽，部分原因是为了对抗象征英格兰的狮子。',
      tags: ['文化', '历史', '苏格兰', '神话']
    },
    {
      id: 'ck12',
      title: '花生不是坚果，而是豆类。',
      brief: '它们在地下生长，属于豆科植物。',
      details: '从植物学角度看，花生是豆科植物的种子，生长在豆荚中，通常在地下成熟。而真正的坚果，如核桃或橡子，是具有坚硬外壳和单一果仁的果实。',
      tags: ['植物', '食物', '科学', '分类学']
    },
    {
      id: 'ck13',
      title: '"OK"这个词的起源有多种说法，最流行的是来自"oll korrect"。',
      brief: '19世纪波士顿的一种幽默拼写方式。',
      details: '"OK"被认为是在19世纪30年代末波士顿流行起来的缩写词幽默的一部分，作为"all correct"的错误拼写"oll korrect"的缩写。它因在马丁·范布伦总统竞选中的使用而普及。',
      tags: ['语言', '历史', '词源']
    },
    {
      id: 'ck14',
      title: '世界上第一部动画长片是阿根廷制作的。',
      brief: '《使徒》(El Apóstol) 于1917年上映。',
      details: '由 Quirino Cristiani 执导的阿根廷电影《使徒》是一部讽刺政治的动画片，片长70分钟，使用了剪纸动画技术。不幸的是，这部电影的胶片已遗失。',
      tags: ['电影', '历史', '阿根廷', '动画']
    },
    {
      id: 'ck15',
      title: '海獭睡觉时会手拉手，以防在水流中失散。',
      brief: '这是一种可爱的社群行为。',
      details: '海獭经常在水面上仰面漂浮睡觉，它们会与其他海獭（通常是家庭成员）手拉手或用海藻把自己固定住，以避免在睡觉时被水流冲散。',
      tags: ['动物', '海洋生物', '行为']
    },
    {
      id: 'ck16',
      title: '一茶匙的中子星物质重达数十亿吨。',
      brief: '中子星的密度极高。',
      details: '中子星是大质量恒星坍缩后的核心，其密度非常惊人。如果能从中子星上取下一茶匙（约5毫升）的物质，其质量将达到约60亿吨。',
      tags: ['太空', '物理', '天文学', '科学']
    },
    {
      id: 'ck17',
      title: '"鳄梨"和"牛油果"是同一种水果。',
      brief: '不同地区叫法不同。',
      details: '鳄梨（Avocado）是这种水果的学名和更广泛的称呼，而"牛油果"是中国南方和香港等地常用的商品名，因其果肉质地如牛油般细腻。',
      tags: ['植物', '食物', '语言']
    },
    {
      id: 'ck18',
      title: '人类的DNA有50%和香蕉相同。',
      brief: '这反映了所有生物共享一些基本生命功能的基因。',
      details: '虽然听起来很惊人，但这并不意味着我们一半是香蕉。许多生物共享控制基本细胞功能（如细胞呼吸、蛋白质合成）的基因。这些基因在进化过程中高度保守。',
      tags: ['科学', '基因', '人体', '植物']
    },
    {
      id: 'ck19',
      title: '世界上最长的地名有85个字母。',
      brief: '位于新西兰，通常简称为Taumata。',
      details: '这个毛利语地名是 Taumatawhakatangihangakoauauotamateaturipukakapikimaungahoronukupokaiwhenuakitanatahu，大致意思是"一个有着大膝盖、名叫塔马特阿的男人，他滑下、爬上和吞没了山脉，他为他心爱的人吹奏鼻笛的山顶"。',
      tags: ['地理', '语言', '新西兰', '记录']
    },
    {
      id: 'ck20',
      title: '树懒每周只排便一次。',
      brief: '它们的代谢非常缓慢。',
      details: '虽然骨骼在青春期后停止生长，但构成鼻子和耳朵的软骨会随着年龄的增长而缓慢地继续生长。此外，皮肤弹性的丧失和重力作用也会使它们看起来更大更长。',
      tags: ['动物', '哺乳动物', '行为']
    },
    {
      id: 'ck21',
      title: '"乐高"这个名字来源于丹麦语"leg godt"，意思是"好好玩"。',
      brief: '一个简单的愿望成就了伟大的品牌。',
      details: '乐高集团的创始人 Ole Kirk Christiansen 在1934年为他的木制玩具公司选择了这个名字，取自丹麦短语"leg godt"。巧合的是，"lego"在拉丁语中也有"我拼装"的意思。',
      tags: ['品牌', '语言', '丹麦', '玩具']
    },
    {
      id: 'ck22',
      title: '鸵鸟的眼睛比它的大脑还大。',
      brief: '它们的眼睛直径可达5厘米。',
      details: '鸵鸟拥有陆地动物中最大的眼睛，这为它们提供了出色的视力，有助于在开阔的平原上发现捕食者。相比之下，它们的大脑相对较小。',
      tags: ['动物', '鸟类', '解剖学']
    },
    {
      id: 'ck23',
      title: '蜂蜜永远不会变质。',
      brief: '考古学家在古埃及坟墓中发现了数千年仍可食用的蜂蜜。',
      details: '蜂蜜的高糖浓度和低水分含量使其成为不适宜细菌和微生物生长的环境。此外，蜂蜜中含有少量过氧化氢，也具有抗菌作用。只要储存得当，避免水分进入，蜂蜜可以保存非常久。',
      tags: ['食物', '科学', '历史']
    },
    {
      id: 'ck24',
      title: '大象是唯一不会跳跃的哺乳动物。',
      brief: '它们的骨骼结构和体重使其无法跳跃。',
      details: '成年大象体重可达数吨，它们的腿部骨骼结构设计用来支撑巨大的重量，而不是进行跳跃所需的爆发力。即使是小象也不会跳跃。',
      tags: ['动物', '哺乳动物', '科学']
    },
    {
      id: 'ck25',
      title: '蜗牛可以睡三年。',
      brief: '它们在极端干旱时进入长时间休眠。',
      details: '当环境极度干燥时，蜗牛会进入一种称为"夏眠"的状态，最长可持续三年，直到环境变得湿润适合活动。',
      tags: ['动物', '生理', '极端环境']
    },
    {
      id: 'ck26',
      title: '世界上最重的水果是南瓜。',
      brief: '巨型南瓜可重达一吨以上。',
      details: '目前世界纪录的巨型南瓜重达1,190公斤，是所有水果中最重的。',
      tags: ['植物', '记录', '食物']
    },
    {
      id: 'ck27',
      title: '企鹅有膝盖，只是藏在羽毛下。',
      brief: '它们的膝盖被厚厚的羽毛覆盖。',
      details: '企鹅的腿部结构和大多数鸟类一样有膝盖，只是由于羽毛和脂肪的覆盖，外观上看不出来。',
      tags: ['动物', '鸟类', '解剖学']
    },
    {
      id: 'ck28',
      title: '蜂鸟是唯一能倒着飞的鸟。',
      brief: '它们的翅膀可以360度旋转。',
      details: '蜂鸟的翅膀关节极为灵活，可以实现悬停、倒飞等复杂动作，是唯一能做到倒飞的鸟类。',
      tags: ['动物', '鸟类', '飞行']
    },
    {
      id: 'ck29',
      title: '人类一天大约眨眼2万次。',
      brief: '眨眼不仅润滑眼球，还帮助大脑短暂休息。',
      details: '平均每分钟眨眼15-20次，一天加起来约2万次。眨眼还能让大脑短暂"断线"，有助于信息处理。',
      tags: ['人体', '生理', '神经科学']
    },
    {
      id: 'ck30',
      title: '章鱼的血液是蓝色的。',
      brief: '它们用铜基血蓝蛋白运输氧气。',
      details: '章鱼血液中的血蓝蛋白含铜，遇氧变蓝，适合深海低温低氧环境。',
      tags: ['动物', '海洋生物', '科学']
    },
    {
      id: 'ck31',
      title: '世界上最小的哺乳动物是蜂鸟蝠。',
      brief: '体重不足2克，仅拇指大小。',
      details: '蜂鸟蝠又称"基蒂猪鼻蝙蝠"，生活在泰国和缅甸的洞穴中，是已知体型最小的哺乳动物。',
      tags: ['动物', '哺乳动物', '记录']
    },
    {
      id: 'ck32',
      title: '闪电比太阳表面还热。',
      brief: '闪电温度可达3万摄氏度。',
      details: '闪电瞬间温度高达30,000°C，而太阳表面约为5,500°C。',
      tags: ['自然现象', '物理', '天气']
    },
    {
      id: 'ck33',
      title: '长颈鹿的舌头可以长达50厘米。',
      brief: '舌头呈深蓝色，可灵活卷起树叶。',
      details: '长颈鹿用长舌头卷取高处树叶，舌头颜色深可防晒。',
      tags: ['动物', '解剖学', '行为']
    },
    {
      id: 'ck34',
      title: '世界上最古老的树龄超过4800年。',
      brief: '加州的狐尾松是目前已知最古老的单体树。',
      details: '加州白山的狐尾松"莫休斯拉"树龄约4850年，是地球上最古老的单体树木。',
      tags: ['植物', '记录', '自然']
    },
    {
      id: 'ck35',
      title: '猫用胡须判断空间宽度。',
      brief: '胡须帮助猫感知是否能通过狭窄空间。',
      details: '猫的胡须长度通常与身体宽度相当，可以帮助它们判断能否穿过狭小缝隙。',
      tags: ['动物', '行为', '生理']
    },
    {
      id: 'ck36',
      title: '海豚会用名字互相呼唤。',
      brief: '每只海豚有独特的口哨声作为"名字"。',
      details: '研究发现，海豚通过独特的口哨声识别并呼叫彼此，类似人类的名字。',
      tags: ['动物', '行为', '交流']
    },
    {
      id: 'ck37',
      title: '南极洲是地球上唯一没有爬行动物的大陆。',
      brief: '极端低温让爬行动物无法生存。',
      details: '由于极端寒冷，南极洲没有原生的蛇、蜥蜴等爬行动物。',
      tags: ['地理', '动物', '极地']
    },
    {
      id: 'ck38',
      title: '世界上最辣的辣椒是"卡罗莱纳死神"。',
      brief: '辣度高达220万史高维尔单位。',
      details: '"卡罗莱纳死神"辣椒的辣度远超普通辣椒，被吉尼斯认证为最辣辣椒。',
      tags: ['食物', '植物', '记录']
    },
    {
      id: 'ck39',
      title: '人类出生时膝盖没有骨头。',
      brief: '婴儿膝盖为软骨，长大后才骨化。',
      details: '新生儿的膝盖主要由软骨组成，随着成长逐渐骨化形成骨头。',
      tags: ['人体', '生理', '发育']
    },
    {
      id: 'ck40',
      title: '乌龟可以通过屁股呼吸。',
      brief: '部分淡水龟能通过泄殖腔吸收氧气。',
      details: '在冬眠或缺氧环境下，某些龟类能通过泄殖腔的特殊结构进行气体交换。',
      tags: ['动物', '生理', '奇趣']
    },
    {
      id: 'ck41',
      title: '世界上最短的战争只持续了38分钟。',
      brief: '1896年英国与桑给巴尔的战争。',
      details: '1896年，英国与桑给巴尔苏丹国爆发战争，仅38分钟后桑给巴尔投降，创下最短战争纪录。',
      tags: ['历史', '战争', '记录']
    },
    {
      id: 'ck42',
      title: '蚂蚁不会睡觉，但会定期小憩。',
      brief: '蚂蚁以短暂休息代替睡眠。',
      details: '蚂蚁没有像人类那样的深度睡眠，而是以极短的周期进行休息，平均每35分钟休息1分钟。',
      tags: ['动物', '行为', '生理']
    },
    {
      id: 'ck43',
      title: '彩虹其实是圆的，只是地面遮挡了下半部分。',
      brief: '从高空可见完整圆形彩虹。',
      details: '彩虹实际上是一个完整的圆环，地面上的观察者只能看到上半部分。',
      tags: ['自然现象', '光学', '天气']
    },
    {
      id: 'ck44',
      title: '树木也会"流汗"。',
      brief: '树木通过蒸腾作用释放水分。',
      details: '树木通过叶片将水分蒸发到空气中，这一过程称为蒸腾作用，有助于调节温度和水分运输。',
      tags: ['植物', '生理', '生态']
    },
    {
      id: 'ck45',
      title: '人类的胃每三到四天就会更换一次内壁细胞。',
      brief: '以抵御强酸腐蚀。',
      details: '胃酸极为强烈，为防止自我消化，胃内壁细胞每几天就会被新细胞替换。',
      tags: ['人体', '生理', '再生']
    },
    {
      id: 'ck46',
      title: '北极没有企鹅，南极没有北极熊。',
      brief: '两者分布于地球两极，但从不相遇。',
      details: '北极熊生活在北极圈，企鹅分布在南半球，二者生活环境完全不同。',
      tags: ['动物', '地理', '极地']
    },
    {
      id: 'ck47',
      title: '世界上最长寿的动物是一只名叫明的蛤蜊，活了507年。',
      brief: '明蛤于2006年被发现时已507岁。',
      details: '这只名为"明"的大西洋蛤蜊（Arctica islandica）通过壳层年轮判定年龄，创下动物最长寿纪录。',
      tags: ['动物', '寿命', '记录']
    },
    {
      id: 'ck48',
      title: '地球上99%的金属都在地核。',
      brief: '地幔和地壳的金属含量远低于地核。',
      details: '地球形成早期，重金属因密度高下沉至地核，地壳中仅存少量金属元素。',
      tags: ['地理', '地球科学', '金属']
    },
    {
      id: 'ck49',
      title: '鸽子会认路，是因为能感知地磁场。',
      brief: '鸽子体内有"磁感应器"。',
      details: '鸽子鼻腔和脑内有专门感知地磁场的细胞，帮助它们完成远距离定向飞行。',
      tags: ['动物', '导航', '科学']
    },
    {
      id: 'ck50',
      title: '世界上最深的湖是贝加尔湖。',
      brief: '最深处达1642米，水体极为清澈。',
      details: '贝加尔湖位于俄罗斯西伯利亚，是世界上最深和最古老的淡水湖。',
      tags: ['地理', '水体', '记录']
    },
    {
      id: 'ck51',
      title: '人类的指纹和舌纹都独一无二。',
      brief: '每个人的舌头表面纹路也不相同。',
      details: '指纹众所周知独特，其实舌头表面的纹路也具有唯一性，可用于身份识别。',
      tags: ['人体', '生理', '识别']
    },
    {
      id: 'ck52',
      title: '世界上最小的鸟是蜂鸟。',
      brief: '古巴的吸蜜蜂鸟体重不足2克。',
      details: '吸蜜蜂鸟是现存最小的鸟类，体长约5厘米，体重不到2克。',
      tags: ['动物', '鸟类', '记录']
    },
    {
      id: 'ck53',
      title: '鲸鱼的心脏可重达一吨。',
      brief: '蓝鲸心脏是地球上最大的心脏。',
      details: '蓝鲸心脏重约600-1000公斤，相当于一辆小汽车。',
      tags: ['动物', '海洋生物', '解剖学']
    },
    {
      id: 'ck54',
      title: '世界上最长的昆虫是马来西亚巨竹节虫。',
      brief: '体长可达60厘米。',
      details: '马来西亚巨竹节虫以其极端的体长和伪装能力著称，是已知最长的昆虫。',
      tags: ['动物', '昆虫', '记录']
    }
  ],
  'strange-questions': [
    {
      id: 'sq1',
      title: '假如月亮是一块奶酪，它会怎么影响地球？',
      brief: '除了香味，可能还有很多引力问题。',
      details: '如果月亮的质量和密度与奶酪相似，它的引力会大大减小，潮汐现象会减弱。而且，奶酪月亮可能会被地球引力撕碎，或者在太空中变质。',
      tags: ['太空', '脑洞', '物理']
    },
    {
      id: 'sq2',
      title: "小时候玩的游戏'地上是岩浆'其实在心理学上有解释？",
      brief: '这可能与人类的进化和风险感知有关。',
      details: '这种游戏模拟了危险环境，帮助儿童在安全的环境中练习风险评估和规避行为。它也反映了人类对危险环境（如高处、不稳定地面）的本能警惕。',
      tags: ['心理学', '童年', '行为']
    },
    {
      id: 'sq3',
      title: '如果时间倒流，你会变成婴儿还是直接消失？',
      brief: '这是一个经典的哲学和物理学悖论。',
      details: '从物理学角度看，时间倒流在宏观尺度上不被认为可能。从哲学角度看，这涉及到身份的连续性问题。不同的理论有不同的解释，没有统一答案。',
      tags: ['哲学', '物理', '时间旅行', '脑洞']
    },
    {
      id: 'sq4',
      title: '为什么我们打哈欠会传染？',
      brief: '可能是因为同理心和社交同步行为。',
      details: '打哈欠传染的确切原因仍在研究中，但主流理论认为这与人类（以及一些动物）的同理心和社会联系有关。看到别人打哈欠可能会激活我们大脑中与模仿和社交行为相关的区域。',
      tags: ['行为', '心理学', '科学', '人体']
    },
    {
      id: 'sq5',
      title: '如果地球突然停止自转，会发生什么？',
      brief: '地表的一切都会以极高速度被甩出去。',
      details: '地球的赤道处的自转速度约为每小时1670公里。如果地球突然停止，地表物体会因惯性继续以这个速度运动，造成毁灭性的灾难，包括极端天气、巨大的海啸和地壳变动。',
      tags: ['物理', '灾难', '地球科学', '脑洞']
    },
    {
      id: 'sq6',
      title: '为什么数字"7"在很多文化中被认为是幸运数字？',
      brief: '可能与宗教、自然现象和数学特性有关。',
      details: '数字7在许多文化和宗教中都有特殊意义（如一周七天，七宗罪，彩虹七色）。它也是一个素数，具有一些独特的数学属性。这些因素可能共同促成了它"幸运"的声誉。',
      tags: ['文化', '数字', '历史', '信仰']
    },
    {
      id: 'sq7',
      title: '如果动物会说话，它们会抱怨些什么？',
      brief: '食物、栖息地、人类活动可能是主要话题。',
      details: '宠物可能会抱怨伙食单调或孤独。野生动物可能会抱怨栖息地丧失、环境污染和人类的干扰。当然，它们也可能会分享我们不知道的快乐。',
      tags: ['动物', '脑洞', '幽默', '想象']
    },
    {
      id: 'sq8',
      title: '为什么我们闭上眼睛才能睡着？',
      brief: '减少光线刺激和帮助大脑放松。',
      details: '闭眼可以阻挡光线进入视网膜，减少对大脑的刺激，有助于褪黑激素的分泌，从而促进睡眠。它也是一种发出"准备休息"信号的本能行为。',
      tags: ['人体', '睡眠', '科学']
    },
    {
      id: 'sq9',
      title: '如果重力减半，生活会怎样？',
      brief: '我们会跳得更高，东西会更轻，但可能有很多副作用。',
      details: '我们会变得更高，因为脊椎压力减小。物体更容易举起。但大气层可能会变薄，肌肉和骨骼可能会退化，地球的形态和轨道也可能受影响。',
      tags: ['物理', '脑洞', '科学幻想']
    },
    {
      id: 'sq10',
      title: '为什么有些歌会"洗脑"，一直在脑子里循环？',
      brief: '这叫做"耳虫效应"。',
      details: '耳虫（earworm）通常是结构简单、重复性高、节奏感强的歌曲片段。大脑的听觉皮层可能会在没有外部声音时自发激活，重复播放这些片段。疲劳或压力也可能诱发。',
      tags: ['心理学', '音乐', '大脑', '现象']
    },
    {
      id: 'sq11',
      title: '如果人类有翅膀，交通会变成什么样？',
      brief: '可能会有空中交通堵塞和飞行驾照。',
      details: '个人飞行可能会普及，但随之而来的是空中交通管制、飞行安全法规、起降平台建设等问题。建筑物的设计也需要适应。',
      tags: ['想象', '科技', '社会', '脑洞']
    },
    {
      id: 'sq12',
      title: '为什么冰是滑的？',
      brief: '压力融化和表面液体层是主要原因。',
      details: '当物体（如冰鞋）压在冰上时，压力会使冰的熔点降低，形成一层薄薄的水膜，起到润滑作用。此外，即使没有压力，冰的表面也存在一层类似液体的薄层。',
      tags: ['物理', '科学', '日常现象']
    },
    {
      id: 'sq13',
      title: '如果植物能感知疼痛，素食还道德吗？',
      brief: '这是一个复杂的伦理学问题。',
      details: '目前科学认为植物没有类似动物的神经系统来感知疼痛。但如果它们能，那么获取食物的伦理边界会变得更模糊，可能需要重新评估所有生命形式的价值。',
      tags: ['哲学', '伦理', '素食主义', '植物']
    },
    {
      id: 'sq14',
      title: '为什么镜子里的影像是左右颠倒，而不是上下颠倒？',
      brief: '其实是前后颠倒。',
      details: '镜子反射的是光线，它实际上是沿着垂直于镜面的轴线（即前后方向）反转了影像。我们感觉是左右颠倒，是因为我们习惯于通过旋转来比较自己和镜像。',
      tags: ['物理', '光学', '错觉']
    },
    {
      id: 'sq15',
      title: '如果人死后体重会减轻21克，那是什么东西的重量？',
      brief: '这是一个有争议且未被科学证实的实验。',
      details: '20世纪初，邓肯·麦克杜格尔医生进行实验称人死后体重减轻约21克，并推测这是"灵魂的重量"。但其实验方法和结果受到广泛质疑，科学界普遍不接受此说法。',
      tags: ['伪科学', '历史', '都市传说', '争议']
    },
    {
      id: 'sq16',
      title: '为什么有些歌会"洗脑"，一直在脑子里循环？',
      brief: '这叫做"耳虫效应"。',
      details: '耳虫（earworm）通常是结构简单、重复性高、节奏感强的歌曲片段。大脑的听觉皮层可能会在没有外部声音时自发激活，重复播放这些片段。疲劳或压力也可能诱发。',
      tags: ['心理学', '音乐', '大脑', '现象']
    },
    {
      id: 'sq17',
      title: '如果地球上的所有昆虫突然消失，会发生什么？',
      brief: '生态系统会崩溃，人类可能难以生存。',
      details: '昆虫在生态系统中扮演关键角色，如传粉、分解有机物、作为食物链基础等。它们的消失将导致植物大量灭绝，食物链断裂，最终可能导致全球性的生态灾难。',
      tags: ['生态', '生物', '灾难', '科学']
    },
    {
      id: 'sq18',
      title: '为什么梦境常常很荒诞，我们却不觉得奇怪？',
      brief: '做梦时大脑的逻辑和审查功能减弱。',
      details: '在快速眼动睡眠（REM）阶段，大脑前额叶皮层（负责逻辑推理和决策）的活动水平降低，而情绪中枢（如杏仁核）则非常活跃，导致梦境充满情感色彩但缺乏逻辑连贯性。',
      tags: ['心理学', '大脑', '睡眠', '梦境']
    },
    {
      id: 'sq19',
      title: '如果人类的平均寿命是500岁，社会结构会怎样？',
      brief: '职业、家庭、教育体系都会发生巨大变化。',
      details: '人们可能会多次转换职业，学习新技能。几代同堂的家庭会更普遍。对资源的需求和代际关系也会变得非常不同。创新和变革的节奏可能会减慢。',
      tags: ['社会', '想象', '未来', '人口']
    },
    {
      id: 'sq20',
      title: '为什么切洋葱会流眼泪？',
      brief: '洋葱释放催泪因子。',
      details: '切洋葱时会破坏其细胞，释放出一种名为蒜氨酸酶的酶，它与洋葱中的含硫化合物反应，产生一种名为丙硫醛-S-氧化物的气体。这种气体接触眼睛后会刺激角膜神经，导致流泪。',
      tags: ['化学', '生活常识', '人体']
    },
    {
      id: 'sq21',
      title: '如果世界上没有了颜色，只有黑白灰，会怎样？',
      brief: '艺术、设计、甚至情绪感知都会大不相同。',
      details: '我们对世界的感知会变得单调。交通信号、品牌识别、自然界的伪装和警告色等都会失效。艺术表达和情绪体验也会受到深刻影响。',
      tags: ['感官', '想象', '艺术', '心理学']
    },
    {
      id: 'sq22',
      title: '为什么挠痒痒自己不觉得痒，别人挠就很痒？',
      brief: '大脑能预测自身行为，降低感知。',
      details: '小脑可以预测由自身动作产生的感觉，并向大脑其他区域发送信号以抑制这些感觉。当别人挠痒时，这种预测机制不起作用，所以感觉更强烈。',
      tags: ['大脑', '神经科学', '人体', '行为']
    },
    {
      id: 'sq23',
      title: '如果人能和动物无障碍交流，世界会和平还是更乱？',
      brief: '可能会揭示很多我们不想知道的真相。',
      details: '我们可能会更理解动物的需求和痛苦，促进和平。但也可能因为资源、领地等问题引发新的冲突，或者动物的"意见"太多导致混乱。',
      tags: ['想象', '伦理', '动物权益', '哲学']
    },
    {
      id: 'sq24',
      title: '为什么天空是蓝色的？',
      brief: '瑞利散射效应。',
      details: '阳光进入大气层时，空气中的微小分子（主要是氮和氧）会散射阳光。蓝光和紫光波长较短，比其他颜色的光更容易被散射，所以我们看到的天空是蓝色的。',
      tags: ['物理', '科学', '大气', '光学']
    },
    {
      id: 'sq25',
      title: '如果人类可以像海豚一样用回声定位，我们会开发出什么新技能？',
      brief: '黑暗中导航、感知物体内部结构可能成为现实。',
      details: '我们或许能在完全黑暗的环境中"看"东西，感知物体的形状、大小、材质甚至内部结构。这可能在医学、工程、探险等领域有新应用。',
      tags: ['想象', '生物', '科技', '感官']
    },
    {
      id: 'sq26',
      title: '为什么有些地方的路面是红色的？',
      brief: '通常是出于安全或特殊用途的考虑。',
      details: '红色路面常用于公交专用道、自行车道、事故多发区或减速带，以提高可见性，警示驾驶员和行人。有时也用于美化城市景观。',
      tags: ['交通', '城市规划', '安全']
    },
    {
      id: 'sq27',
      title: '如果地球的轴心倾斜度改变了会怎样？',
      brief: '季节变化会变得极端或消失。',
      details: '地球的轴心倾斜（约23.5度）是造成季节变化的原因。如果倾斜度增大，季节温差会更极端；如果倾斜度减小或为零，季节变化会减弱或消失，对气候和生态系统产生巨大影响。',
      tags: ['地球科学', '天文学', '气候', '灾难']
    },
    {
      id: 'sq28',
      title: '为什么我们说"感冒了"，而不是"感热了"？',
      brief: '传统医学观念和症状表现。',
      details: '传统中医认为感冒多由"风寒"引起。从症状看，早期感冒常伴有怕冷、发抖等"寒"性表现。尽管后期可能发热，但最初的"寒"感更深入人心。',
      tags: ['语言', '文化', '医学', '传统']
    },
    {
      id: 'sq29',
      title: '如果人类不需要睡眠，每天多出8小时会用来做什么？',
      brief: '工作、学习、娱乐，或者只是无所事事？',
      details: '初期可能会有生产力的大幅提升，但也可能导致新的社会问题，如过度工作、休闲产业的极度发达，或者人们反而感到更空虚。',
      tags: ['想象', '社会', '生活方式', '未来']
    },
    {
      id: 'sq30',
      title: '为什么爆米花会"爆炸"？',
      brief: '玉米粒内部水分受热膨胀。',
      details: '每颗爆米花玉米粒内部都含有少量水分和淀粉。加热时，水分变成蒸汽，内部压力增大。当压力足够大时，玉米粒外壳破裂，内部淀粉迅速膨胀并凝固，形成我们看到的蓬松爆米花。',
      tags: ['食物', '科学', '物理', '化学']
    },
    {
      id: 'sq31',
      title: '如果人死后体重会减轻21克，那是什么东西的重量？',
      brief: '这是一个有争议且未被科学证实的实验。',
      details: '20世纪初，邓肯·麦克杜格尔医生进行实验称人死后体重减轻约21克，并推测这是"灵魂的重量"。但其实验方法和结果受到广泛质疑，科学界普遍不接受此说法。',
      tags: ['伪科学', '历史', '都市传说', '争议']
    },
    {
      id: 'sq32',
      title: '为什么狗在便便前要转圈？',
      brief: '可能与地球磁场、标记领地或寻找舒适点有关。',
      details: '有研究表明狗可能倾向于使自己的身体与地球南北磁力线对齐。也可能是为了踩平地面、检查周围环境安全，或通过脚上的腺体留下气味标记。',
      tags: ['动物行为', '狗', '科学', '未解之谜']
    },
    {
      id: 'sq33',
      title: '如果全世界的人同时跳起来，会发生什么？',
      brief: '几乎什么都不会发生。',
      details: '虽然听起来很壮观，但所有人类的总质量与地球相比微不足道。即使所有人同时起跳并落地，对地球的震动和轨道影响也几乎可以忽略不计，远小于自然地震或陨石撞击。',
      tags: ['物理', '脑洞', '科学计算']
    },
    {
      id: 'sq34',
      title: '如果地球突然没有引力了会怎样？',
      brief: '所有东西都会飘起来，地球会变成什么样？',
      details: '如果地球失去引力，大气层、海洋和所有生物都会漂浮到太空中。地球本身也会因失去束缚而分崩离析，成为宇宙中的一团碎片。',
      tags: ['物理', '脑洞', '灾难']
    },
    {
      id: 'sq35',
      title: '为什么我们不能自己给自己挠痒痒？',
      brief: '大脑能预测自己的动作，降低了痒感。',
      details: '当我们自己挠痒时，大脑会提前预测到触感，从而抑制了痒的感觉。而别人挠时，这种预测机制不起作用，所以会觉得更痒。',
      tags: ['大脑', '行为', '神经科学']
    },
    {
      id: 'sq36',
      title: '如果所有人都能读心术，社会会变成什么样？',
      brief: '谎言和隐私将不复存在。',
      details: '如果人人都能读心，人与人之间的交流会变得极其直接，但也可能导致信任危机和社会混乱，因为没有人能隐藏真实想法。',
      tags: ['想象', '社会', '心理学']
    },
    {
      id: 'sq37',
      title: '为什么有些人会害怕小丑？',
      brief: '小丑妆容让人难以分辨真实情绪。',
      details: '小丑的夸张妆容掩盖了真实表情，让人难以判断其意图，容易引发不安和恐惧，这种现象被称为"恐小丑症"。',
      tags: ['心理学', '恐惧', '文化']
    },
    {
      id: 'sq38',
      title: '如果人类能像变色龙一样变色，会发生什么？',
      brief: '社交、时尚和安全都会改变。',
      details: '人类如果能随意变色，可能会用来表达情绪、伪装自己或成为时尚潮流，但也可能带来隐私和安全的新问题。',
      tags: ['想象', '生理', '社会']
    },
    {
      id: 'sq39',
      title: '为什么我们会做噩梦？',
      brief: '噩梦可能是大脑处理压力和恐惧的方式。',
      details: '噩梦有助于我们在安全环境下"演练"危险情境，帮助大脑处理负面情绪和压力，是心理自我调节的一种机制。',
      tags: ['梦境', '心理学', '大脑']
    },
    {
      id: 'sq40',
      title: '如果地球上所有猫都消失了，会怎样？',
      brief: '生态系统和人类生活都会受影响。',
      details: '猫是重要的捕鼠者，猫的消失会导致鼠类数量激增，影响农作物和人类健康，同时也会影响与猫相关的文化和经济。',
      tags: ['生态', '动物', '社会']
    },
    {
      id: 'sq41',
      title: '为什么有些人喜欢收集奇怪的东西？',
      brief: '收集癖与心理满足和安全感有关。',
      details: '收集行为可以带来成就感、归属感和安全感，有时也是对童年经历或某种情感的补偿。',
      tags: ['心理学', '行为', '兴趣']
    },
    {
      id: 'sq42',
      title: '如果人类能像植物一样进行光合作用，会怎样？',
      brief: '我们可能不再需要吃饭？',
      details: '如果人类能光合作用，理论上可以靠阳光生存，但由于能量转化效率极低，仍然需要摄入其他营养物质。',
      tags: ['想象', '生物', '科学']
    },
    {
      id: 'sq43',
      title: '为什么我们会有"既视感"？',
      brief: '大脑信息处理短路导致的错觉。',
      details: '"既视感"可能是大脑在处理新信息时，错误地将其归类为记忆，从而产生"好像经历过"的感觉。',
      tags: ['大脑', '心理学', '现象']
    },
    {
      id: 'sq44',
      title: '如果所有动物都能投票选地球总统，会选谁？',
      brief: '动物的选择标准可能和人类完全不同。',
      details: '动物可能会选出最强壮、最聪明或最有组织能力的物种作为"总统"，也可能出现完全出乎人类意料的结果。',
      tags: ['想象', '动物', '社会']
    },
    {
      id: 'sq45',
      title: '为什么有些人会害怕镜子？',
      brief: '镜子中的自我形象可能引发不安。',
      details: '镜子反射的形象有时与自我认知不符，或在昏暗环境下产生错觉，容易引发恐惧和不适。',
      tags: ['心理学', '恐惧', '现象']
    },
    {
      id: 'sq46',
      title: '如果地球上没有昆虫了会怎样？',
      brief: '生态系统将崩溃。',
      details: '昆虫在传粉、分解有机物和食物链中扮演关键角色。没有昆虫，许多植物无法繁殖，生态系统会失衡，最终影响人类生存。',
      tags: ['生态', '灾难', '科学']
    },
    {
      id: 'sq47',
      title: '为什么我们会有"耳鸣"？',
      brief: '耳鸣可能是听觉系统自发活动的结果。',
      details: '耳鸣通常是耳朵或大脑听觉区域异常活动的表现，可能与听力损失、压力或环境噪音有关。',
      tags: ['生理', '健康', '现象']
    },
    {
      id: 'sq48',
      title: '如果人类能像鸟一样飞翔，城市会变成什么样？',
      brief: '城市结构和交通方式将彻底改变。',
      details: '如果人类能自由飞翔，城市将出现更多立体交通、空中平台和高空建筑，地面交通压力大大减轻。',
      tags: ['想象', '城市', '科技']
    },
    {
      id: 'sq49',
      title: '为什么有些人喜欢恐怖片？',
      brief: '恐怖片能带来刺激和安全的"冒险"体验。',
      details: '观看恐怖片时，大脑会释放肾上腺素，让人体验到紧张和刺激，但又知道自己处于安全环境，因此成为一种"可控的冒险"。',
      tags: ['心理学', '娱乐', '行为']
    },
    {
      id: 'sq50',
      title: '如果地球自转速度变快，会发生什么？',
      brief: '一天会变短，气候和生活都受影响。',
      details: '地球自转加快会导致一天变短，赤道地区离心力增强，气候模式和生物节律都会发生变化。',
      tags: ['物理', '地球科学', '脑洞']
    },
    {
      id: 'sq51',
      title: '为什么我们会有"错觉"？',
      brief: '大脑对信息的加工有时会出错。',
      details: '错觉是大脑对外界信息加工时出现的偏差，可能是进化过程中对生存有利的副产品。',
      tags: ['大脑', '心理学', '现象']
    },
    {
      id: 'sq52',
      title: '如果人类能像章鱼一样再生断肢，会怎样？',
      brief: '医疗和生活方式将彻底改变。',
      details: '如果人类能再生断肢，许多伤残将不再是永久性，医疗技术和社会观念都会发生巨大变化。',
      tags: ['想象', '生物', '医学']
    },
    {
      id: 'sq53',
      title: '为什么有些人会害怕高处？',
      brief: '进化中的自我保护机制。',
      details: '对高处的恐惧有助于避免坠落等危险，是进化过程中形成的自我保护机制。',
      tags: ['心理学', '恐惧', '进化']
    },
    {
      id: 'sq54',
      title: '如果地球上所有水都消失了，会发生什么？',
      brief: '生命将无法存续，地球变成荒漠。',
      details: '水是生命的基础，没有水，所有生物都会灭绝，地球表面会变成干燥的荒漠。',
      tags: ['灾难', '生态', '科学']
    },
    {
      id: 'sq55',
      title: '为什么我们会有"幻肢痛"？',
      brief: '大脑仍然保留失去肢体的感觉。',
      details: '即使肢体已经截肢，大脑中负责该部位的区域仍然活跃，导致人们感受到不存在的肢体的疼痛或感觉。',
      tags: ['大脑', '医学', '现象']
    },
    {
      id: 'sq56',
      title: '如果人类能像鱼一样在水下呼吸，会怎样？',
      brief: '水下世界将成为新家园。',
      details: '如果人类能像鱼一样用鳃呼吸，水下城市和社会将成为可能，海洋资源开发和探索也会大大加速。',
      tags: ['想象', '生物', '科技']
    },
    {
      id: 'sq57',
      title: '为什么有些人会害怕黑暗？',
      brief: '黑暗中隐藏着未知和危险。',
      details: '对黑暗的恐惧源于进化时期对夜间捕食者和未知危险的警惕，是人类自我保护的本能。',
      tags: ['心理学', '恐惧', '进化']
    },
    {
      id: 'sq58',
      title: '如果地球上所有声音都消失了，会怎样？',
      brief: '世界会变得极度安静，影响生物交流。',
      details: '没有声音，许多动物无法交流和生存，人类的社会活动和情感表达也会受到极大影响。',
      tags: ['想象', '生物', '社会']
    },
    {
      id: 'sq59',
      title: '为什么我们会有"选择困难症"？',
      brief: '选择过多会让大脑负担加重。',
      details: '当可选项过多时，大脑需要处理的信息量增加，容易导致决策困难和焦虑，这被称为"选择悖论"。',
      tags: ['心理学', '行为', '现象']
    },
    {
      id: 'sq60',
      title: '如果人类能像蝙蝠一样用回声定位，会怎样？',
      brief: '黑暗中导航和感知能力大大增强。',
      details: '如果人类能用回声定位，夜间活动和盲人导航能力将大幅提升，甚至可能发展出全新的运动和艺术形式。',
      tags: ['想象', '生物', '科技']
    },
    {
      id: 'sq61',
      title: '为什么有些人会害怕数字"13"？',
      brief: '文化和历史因素导致的迷信。',
      details: '数字"13"在西方文化中常被视为不吉利，源于宗教、历史事件和集体心理暗示。',
      tags: ['文化', '心理学', '迷信']
    },
    {
      id: 'sq62',
      title: '如果地球上所有植物都消失了，会怎样？',
      brief: '氧气消失，生态系统崩溃。',
      details: '植物是地球氧气的主要来源，没有植物，动物和人类都无法生存，生态系统将彻底崩溃。',
      tags: ['生态', '灾难', '科学']
    },
    {
      id: 'sq63',
      title: '为什么我们会有"拖延症"？',
      brief: '拖延是大脑对压力和任务的应激反应。',
      details: '拖延往往是因为任务带来压力或不确定性，大脑选择短期愉快的活动来逃避不适，从而形成拖延行为。',
      tags: ['心理学', '行为', '现象']
    }
  ],
  'ai-generated': [
    {
      id: 'ai1',
      title: 'AI瞎想：如果蚂蚁有了互联网会怎样？',
      brief: '它们的社会协作可能会达到新的高度，或者陷入信息过载。',
      details: '（由AI生成，纯属娱乐）蚂蚁可能会建立"蚁联网"，共享觅食路线、危险警报，甚至进行复杂的集体决策。但也可能出现"蚁际网络诈骗"或"信息茧房"。',
      tags: ['AI', '脑洞', '科技', '娱乐']
    },
    {
      id: 'ai2',
      title: 'AI瞎想：如果植物学会了编程会发生什么？',
      brief: '它们可能会优化光合作用算法，或者用根系网络挖比特币。',
      details: '（由AI生成，纯属娱乐）向日葵可能会写出更高效的追逐太阳的脚本，食虫草可能会开发出更精准的捕虫App。森林可能会变成一个巨大的分布式计算网络。',
      tags: ['AI', '植物', '编程', '脑洞', '幽默']
    },
    {
      id: 'ai3',
      title: 'AI瞎想：如果云朵有了意识，它们会聊些什么？',
      brief: '可能会抱怨被风吹来吹去，或者讨论哪种形状更受欢迎。',
      details: '（由AI生成，纯属娱乐）积雨云可能会吹嘘自己制造的雷暴有多壮观，卷云则可能在讨论高空时尚。它们或许还会给地上的我们起一些奇怪的绰号。',
      tags: ['AI', '自然', '意识', '想象', '幽默']
    },
    {
      id: 'ai4',
      title: 'AI瞎想：如果影子可以独立行动，它们会做什么？',
      brief: '可能会在主人睡着后开派对，或者偷偷模仿路人。',
      details: '（由AI生成，纯属娱乐）影子们可能会有自己的社会和文化，进行影子戏表演，或者在夜晚进行无声的赛跑。但它们可能害怕光源消失。',
      tags: ['AI', '影子', '奇幻', '脑洞']
    },
    {
      id: 'ai5',
      title: 'AI瞎想：如果数字有了情感，数字"0"会感到孤独吗？',
      brief: '它可能觉得自己一无所有，也可能觉得自己潜力无限。',
      details: '（由AI生成，纯属娱乐）数字"0"可能会因为代表"无"而感到沮丧，但它也可能因为是二进制的基础和一切的起点而感到自豪。它和"1"的关系可能很复杂。',
      tags: ['AI', '数学', '情感', '哲学思考', '幽默']
    },
    {
      id: 'ai6',
      title: 'AI瞎想：如果石头能开口说话，它们会揭露地球多少秘密？',
      brief: '从恐龙时代到人类文明，它们是沉默的见证者。',
      details: '（由AI生成，纯属娱乐）山脉可能会讲述地壳变动的史诗，鹅卵石可能会分享被河流打磨的经历。金字塔的石头可能会透露建造者的真实想法。',
      tags: ['AI', '地质', '历史', '秘密', '脑洞']
    },
    {
      id: 'ai7',
      title: 'AI瞎想：如果梦境可以打包出售，最畅销的会是哪种梦？',
      brief: '飞行、与偶像见面，或者只是一个平静的午后。',
      details: '（由AI生成，纯属娱乐）冒险梦、浪漫梦、成功梦可能会很受欢迎。但也可能有人专门购买"清醒梦"教程，或者"忘却烦恼"的深度睡眠套餐。',
      tags: ['AI', '梦境', '商业', '想象']
    },
    {
      id: 'ai8',
      title: 'AI瞎想：如果时间像河流一样可以分支和汇合，会怎样？',
      brief: '可能会有无数个平行宇宙，或者我们可以选择不同的"时间航道"。',
      details: '（由AI生成，纯属娱乐）每一次选择都可能创造一个新的时间分支。时间旅行者可能会在不同的"历史版本"中穿梭，甚至遇到不同版本的自己。',
      tags: ['AI', '时间旅行', '平行宇宙', '物理', '脑洞']
    },
    {
      id: 'ai9',
      title: 'AI瞎想：如果颜色有味道，你的笑声是什么颜色的？',
      brief: '可能是温暖的橙色，也可能是明亮的金色。',
      details: '（由AI生成，纯属娱乐）尖叫可能是刺眼的红色，耳语可能是柔和的蓝色。我们可以用颜色来"画"出一段对话或一首歌。联觉者可能会觉得这很平常。',
      tags: ['AI', '感官', '联觉', '想象', '艺术']
    },
    {
      id: 'ai10',
      title: 'AI瞎想：如果书中的角色能走出书本，他们会适应现代生活吗？',
      brief: '福尔摩斯可能会沉迷于互联网破案，罗密欧朱丽叶可能会用社交软件谈情。',
      details: '（由AI生成，纯属娱乐）它们可能会组成"树木旅行团"，在不同的气候带体验生活。古老的树木可能会成为经验丰富的导游，讲述各地的故事。',
      tags: ['AI', '文学', '穿越', '文化冲突', '脑洞']
    },
    {
      id: 'ai11',
      title: 'AI瞎想：如果宠物可以发朋友圈，它们的动态会是什么样的？',
      brief: '晒太阳、晒美食、抱怨主人，或者炫耀新玩具。',
      details: '（由AI生成，纯属娱乐）猫可能会发："今天又被愚蠢的人类摸了头，喵~ #无语"。狗可能会发："今天和小区小花一起追蝴蝶啦！#开心"。仓鼠可能在直播跑轮。',
      tags: ['AI', '宠物', '社交媒体', '幽默']
    },
    {
      id: 'ai12',
      title: 'AI瞎想：如果音乐有形状，摇滚乐和古典乐会是什么样子？',
      brief: '摇滚乐可能是尖锐的闪电，古典乐可能是平滑的曲线。',
      details: '（由AI生成，纯属娱乐）爵士乐可能是不规则的多边形，电子音乐可能是流动的光影。我们可以"看到"音乐的节奏和旋律，甚至用3D打印机打印出来。',
      tags: ['AI', '音乐', '艺术', '想象', '感官']
    },
    {
      id: 'ai13',
      title: 'AI瞎想：如果镜子能记录它所映照的一切，最珍贵的记录是什么？',
      brief: '可能是某个人的微笑，也可能是历史性的瞬间。',
      details: '（由AI生成，纯属娱乐）一面古董镜子可能记录了几个世纪的悲欢离合。浴室的镜子可能记录了无数人早晨的睡眼惺忪。它们是无声的历史学家。',
      tags: ['AI', '记忆', '历史', '哲学思考', '脑洞']
    },
    {
      id: 'ai14',
      title: 'AI瞎想：如果情绪可以像天气一样预报，生活会更轻松吗？',
      brief: '"明天心情多云转晴，局部有小脾气。"',
      details: '（由AI生成，纯属娱乐）我们可以提前知道老板今天会不会发火，或者伴侣什么时候需要安慰。但也可能因为预报太准而失去惊喜和真实感。',
      tags: ['AI', '情绪', '科技', '社会', '想象']
    },
    {
      id: 'ai15',
      title: 'AI瞎想：如果城市建筑可以像植物一样生长，城市会是什么样子？',
      brief: '摩天大楼可能会开花结果，街道可能会像藤蔓一样蔓延。',
      details: '（由AI生成，纯属娱乐）它们可能会组成"树木旅行团"，在不同的气候带体验生活。古老的树木可能会成为经验丰富的导游，讲述各地的故事。',
      tags: ['AI', '建筑', '生态', '未来城市', '脑洞']
    },
    {
      id: 'ai16',
      title: 'AI瞎想：如果打喷嚏可以选择音效，你会选什么？',
      brief: '小猫叫、激光枪声，还是系统默认"阿嚏"？',
      details: '（由AI生成，纯属娱乐）开会时可以选择静音模式，看恐怖片时可以选择尖叫模式。感冒时可能会下载一整个"喷嚏音效包"。',
      tags: ['AI', '人体', '声音', '幽默', '科技']
    },
    {
      id: 'ai17',
      title: 'AI瞎想：如果地心是一个巨大的图书馆，藏着什么书？',
      brief: '可能是地球的自传，或者宇宙的未解之谜。',
      details: '（由AI生成，纯属娱乐）每一层地壳可能都对应着不同年代的书籍。内核深处可能藏着关于生命起源或宇宙终极命运的孤本。只有最勇敢的探险家才能阅读。',
      tags: ['AI', '地球科学', '图书馆', '秘密', '奇幻']
    },
    {
      id: 'ai18',
      title: 'AI瞎想：如果鱼有腿了，它们会上岸做什么？',
      brief: '可能会去沙滩晒太阳，或者开一家海底捞陆地分店。',
      details: '（由AI生成，纯属娱乐）它们可能会参加马拉松比赛，或者学习人类的语言和文化。但也可能因为不适应陆地空气而需要特制"氧气头盔"。',
      tags: ['AI', '动物进化', '想象', '幽默']
    },
    {
      id: 'ai19',
      title: 'AI瞎想：如果每个想法都会在头顶上显示为弹幕，社交会怎样？',
      brief: '诚实度爆表，但也可能"社死"现场不断。',
      details: '（由AI生成，纯属娱乐）你一眼就能看出谁在说谎，谁在暗恋你。开会时老板头上的弹幕可能是："快点结束吧，我要去钓鱼。"但也可能因为想法太直接而引发冲突。',
      tags: ['AI', '社交', '读心术', '科技', '脑洞']
    },
    {
      id: 'ai20',
      title: 'AI瞎想：如果垃圾桶有了智能和情感，它们会对人类说什么？',
      brief: '"求求你们，垃圾分类！"或者"我今天又吃到了限量版薯片袋！"',
      details: '（由AI生成，纯属娱乐）它们可能会抱怨工作环境差，或者为自己"消化"了有害垃圾而自豪。智能垃圾桶之间可能会有自己的社交网络，分享"美食"情报。',
      tags: ['AI', '环保', '人工智能', '幽默', '城市生活']
    },
    {
      id: 'ai21',
      title: 'AI瞎想：如果星星是天空的神经元，宇宙在思考什么？',
      brief: '可能在思考存在的意义，或者只是在做白日梦。',
      details: '（由AI生成，纯属娱乐）星系可能是宇宙大脑的不同区域，黑洞可能是记忆的存储点。宇宙可能在进行一场漫长而深刻的哲学思辨，或者只是在随机生成新的想法（比如新的物理定律）。',
      tags: ['AI', '宇宙', '哲学', '意识', '脑洞']
    },
    {
      id: 'ai22',
      title: 'AI瞎想：如果键盘上的按键有生命，它们最怕什么？',
      brief: '可能是大力金刚指，或者是咖啡和可乐。',
      details: '（由AI生成，纯属娱乐）空格键可能因为最常被敲击而感到疲惫，而不常用的Scroll Lock键可能感到孤独。它们可能会在夜深人静时开会，抱怨自己的命运。',
      tags: ['AI', '科技', '拟人', '幽默']
    },
    {
      id: 'ai23',
      title: 'AI瞎想：如果声音有颜色，你的笑声是什么颜色的？',
      brief: '可能是温暖的橙色，也可能是明亮的金色。',
      details: '（由AI生成，纯属娱乐）尖叫可能是刺眼的红色，耳语可能是柔和的蓝色。我们可以用颜色来"画"出一段对话或一首歌。联觉者可能会觉得这很平常。',
      tags: ['AI', '感官', '联觉', '想象', '艺术']
    },
    {
      id: 'ai24',
      title: 'AI瞎想：如果影子是另一个维度的生物，它们如何看待我们？',
      brief: '可能觉得我们是笨拙的、无法穿透墙壁的"实体"。',
      details: '（由AI生成，纯属娱乐）它们可能生活在一个二维世界，我们的三维活动在它们看来是不可思议的变形。它们可能会试图与我们交流，但我们无法理解它们的"语言"。',
      tags: ['AI', '维度', '影子', '科幻', '脑洞']
    },
    {
      id: 'ai25',
      title: 'AI瞎想：如果树木可以自由迁徙，它们会去哪里度假？',
      brief: '热带雨林可能会去北极体验极光，沙漠的仙人掌可能会去海边。',
      details: '（由AI生成，纯属娱乐）它们可能会组成"树木旅行团"，在不同的气候带体验生活。古老的树木可能会成为经验丰富的导游，讲述各地的故事。',
      tags: ['AI', '植物', '旅行', '想象', '幽默']
    },
    {
      id: 'ai26',
      title: 'AI瞎想：如果人类的记忆可以像文件一样复制粘贴，会发生什么？',
      brief: '学习新技能可能只需一秒，但也可能出现身份混乱。',
      details: '（由AI生成，纯属娱乐）你可以轻松"下载"一本百科全书，或者"粘贴"一段快乐的假期记忆。但也可能有人恶意篡改或删除你的记忆，甚至"盗用"你的整个人生。',
      tags: ['AI', '记忆', '科技伦理', '科幻', '脑洞']
    },
    {
      id: 'ai27',
      title: 'AI瞎想：如果枕头能吸收并播放梦境，你会看自己的梦吗？',
      brief: '可能会发现很多潜意识的秘密，也可能被噩梦吓到。',
      details: '（由AI生成，纯属娱乐）我们可以分享有趣的梦，或者请"解梦师"分析录制的梦境。但也可能因为隐私问题而引发争议，或者有人沉迷于观看别人的梦。',
      tags: ['AI', '梦境', '科技', '隐私', '想象']
    },
    {
      id: 'ai28',
      title: 'AI瞎想：如果衣服有情绪，它们最喜欢和最讨厌什么场合？',
      brief: '礼服可能喜欢派对，运动服可能讨厌被汗水浸湿后不洗。',
      details: '（由AI生成，纯属娱乐）睡衣可能最喜欢周末的早晨，而被遗忘在衣柜角落的旧衣服可能会感到孤独和悲伤。它们可能会联合起来"抗议"主人的某些搭配。',
      tags: ['AI', '时尚', '拟人', '幽默', '生活']
    },
    {
      id: 'ai29',
      title: 'AI瞎想：如果标点符号有了性格，句号和问号会是怎样的朋友？',
      brief: '句号可能沉稳果断，问号可能好奇心重。',
      details: '（由AI生成，纯属娱乐）感叹号可能热情洋溢，省略号可能优柔寡断。它们在文本中共同协作，表达复杂的情感和意义。可能会有"标点符号匿名者互助会"。',
      tags: ['AI', '语言', '文学', '拟人', '幽默']
    },
    {
      id: 'ai30',
      title: 'AI瞎想：如果风有记忆，它会讲述怎样的故事？',
      brief: '从山谷的低语到海洋的咆哮，它见证了世界的变迁。',
      details: '（由AI生成，纯属娱乐）春天的风可能记得花开的喜悦，冬天的风可能记得雪落的寂静。它可能携带者远方的信息，或者古老文明的歌谣。',
      tags: ['AI', '自然', '记忆', '诗意', '想象']
    },
    {
      id: 'ai31',
      title: 'AI瞎想：如果食物会说话，你的冰箱里每天有多热闹？',
      brief: '蔬菜可能在讨论保鲜秘诀，剩菜可能在抱怨被遗忘。',
      details: '（由AI生成，纯属娱乐）牛奶可能在快过期时大喊"喝我！"，冰淇淋可能在诱惑你打开冷冻室。它们可能会开"冰箱派对"，或者进行"谁先被吃掉"的比赛。',
      tags: ['AI', '食物', '生活', '幽默', '脑洞']
    },
    {
      id: 'ai32',
      title: 'AI瞎想：如果月亮是一个巨大的奶酪工厂，会发生什么？',
      brief: '地球人可能每天都能吃到新鲜月亮奶酪。',
      details: '（由AI生成，纯属娱乐）宇航员将成为奶酪师傅，月球表面布满奶牛和巨型搅拌机。地球夜空会变成奶酪广告牌。',
      tags: ['AI', '月亮', '奶酪', '脑洞', '幽默']
    },
    {
      id: 'ai33',
      title: 'AI瞎想：如果影子能独立生活，它们会搬去哪？',
      brief: '也许会选择永远有阳光的地方。',
      details: '（由AI生成，纯属娱乐）影子们可能在沙漠建造自己的城市，举办"最长影子大赛"，还会开设"光线健身房"。',
      tags: ['AI', '影子', '想象', '幽默']
    },
    {
      id: 'ai34',
      title: 'AI瞎想：如果猫会编程，互联网会变成什么样？',
      brief: '猫咪网站和逗猫程序将统治世界。',
      details: '（由AI生成，纯属娱乐）所有网页都自动弹出激光笔动画，服务器定期"午睡"，验证码全是鱼干图片。',
      tags: ['AI', '猫', '互联网', '幽默', '科技']
    },
    {
      id: 'ai35',
      title: 'AI瞎想：如果雨滴有情感，下雨天会怎样？',
      brief: '有的雨滴可能会故意避开你，有的会争着落在你头上。',
      details: '（由AI生成，纯属娱乐）雨滴们会在云端开会，决定去哪片城市"旅游"，有的喜欢跳伞，有的喜欢滑滑梯。',
      tags: ['AI', '天气', '情感', '幽默']
    },
    {
      id: 'ai36',
      title: 'AI瞎想：如果鞋子能自己走路，你还需要走路吗？',
      brief: '鞋子可能会带你去它们喜欢的地方。',
      details: '（由AI生成，纯属娱乐）有的鞋子喜欢逛公园，有的喜欢去商场。你可能每天都要和鞋子"商量"路线。',
      tags: ['AI', '鞋子', '生活', '幽默']
    },
    {
      id: 'ai37',
      title: 'AI瞎想：如果镜子能说话，它最常说什么？',
      brief: '"今天你真帅！"还是"又熬夜啦？"',
      details: '（由AI生成，纯属娱乐）镜子会点评你的穿搭，提醒你微笑，偶尔还会八卦隔壁镜子的故事。',
      tags: ['AI', '镜子', '幽默', '生活']
    },
    {
      id: 'ai38',
      title: 'AI瞎想：如果书本能自己写内容，会写些什么？',
      brief: '也许会写自己的"吐槽日记"。',
      details: '（由AI生成，纯属娱乐）书本会抱怨被压在最底下，或者自夸封面多漂亮。它们还会写"如何防止被借走不还"。',
      tags: ['AI', '书本', '幽默', '想象']
    },
    {
      id: 'ai39',
      title: 'AI瞎想：如果冰箱有社交账号，会发什么动态？',
      brief: '"今天又多了两瓶可乐，开心！"',
      details: '（由AI生成，纯属娱乐）冰箱会晒自己的"存货"，抱怨被塞太满，偶尔还会和微波炉互怼。',
      tags: ['AI', '家电', '社交', '幽默']
    },
    {
      id: 'ai40',
      title: 'AI瞎想：如果马路会说话，交通会变得更顺畅吗？',
      brief: '马路可能会提醒你"别闯红灯"。',
      details: '（由AI生成，纯属娱乐）马路会和红绿灯一起唱歌，遇到堵车时会安慰司机："别急，慢慢来。"',
      tags: ['AI', '交通', '幽默', '城市']
    },
    {
      id: 'ai41',
      title: 'AI瞎想：如果时间可以倒着走，你会先做什么？',
      brief: '也许会先吃回昨天的晚饭。',
      details: '（由AI生成，纯属娱乐）人们会先变年轻，饭菜会从肚子里"回到"盘子，手机电量永远用不完。',
      tags: ['AI', '时间', '想象', '幽默']
    },
    {
      id: 'ai42',
      title: 'AI瞎想：如果枕头能播放梦境广告，会出现什么？',
      brief: '"今晚特价美梦，买一送一！"',
      details: '（由AI生成，纯属娱乐）枕头会推送"飞翔梦""中奖梦"等套餐，还能根据你心情定制梦境。',
      tags: ['AI', '梦境', '广告', '幽默']
    },
    {
      id: 'ai43',
      title: 'AI瞎想：如果电梯有情绪，早高峰会怎样？',
      brief: '电梯可能会"罢工"或"加班"。',
      details: '（由AI生成，纯属娱乐）有的电梯喜欢人多热闹，有的喜欢安静。遇到超载时会"假装听不见"。',
      tags: ['AI', '电梯', '情绪', '幽默']
    },
    {
      id: 'ai44',
      title: 'AI瞎想：如果雨伞能预测天气，会提前提醒你吗？',
      brief: '"明天别忘了带我哦！"',
      details: '（由AI生成，纯属娱乐）雨伞会根据天气预报自己跳出来，还会和太阳镜争宠。',
      tags: ['AI', '雨伞', '天气', '幽默']
    },
    {
      id: 'ai45',
      title: 'AI瞎想：如果牙刷能点评你的刷牙技术，会说什么？',
      brief: '"今天右下角没刷干净哦！"',
      details: '（由AI生成，纯属娱乐）牙刷会给你打分，推荐新口味牙膏，还会和牙线比赛谁更重要。',
      tags: ['AI', '牙刷', '健康', '幽默']
    },
    {
      id: 'ai46',
      title: 'AI瞎想：如果垃圾桶能选择"吃什么"，会挑食吗？',
      brief: '垃圾桶可能只喜欢吃薯片袋。',
      details: '（由AI生成，纯属娱乐）垃圾桶会拒绝吃蔬菜叶子，最爱限量版零食包装，还会和回收箱争抢"美食"。',
      tags: ['AI', '垃圾桶', '生活', '幽默']
    },
    {
      id: 'ai47',
      title: 'AI瞎想：如果宠物能给你打分，你会得几分？',
      brief: '猫可能只给60分，狗会给满分。',
      details: '（由AI生成，纯属娱乐）宠物会根据你的投喂、陪玩和铲屎表现打分，还会在朋友圈晒"主人排行榜"。',
      tags: ['AI', '宠物', '评分', '幽默']
    },
    {
      id: 'ai48',
      title: 'AI瞎想：如果植物能发短信，会聊什么？',
      brief: '"今天又晒太阳了，好开心！"',
      details: '（由AI生成，纯属娱乐）植物会互相分享浇水心得，抱怨被虫子咬，还会晒"新叶子自拍"。',
      tags: ['AI', '植物', '社交', '幽默']
    },
    {
      id: 'ai49',
      title: 'AI瞎想：如果马桶能发表情包，会用什么？',
      brief: '"便便表情"可能最受欢迎。',
      details: '（由AI生成，纯属娱乐）马桶会用"冲水""堵塞""干净"等表情，还会和洗手池比谁更忙。',
      tags: ['AI', '马桶', '表情包', '幽默']
    },
    {
      id: 'ai50',
      title: 'AI瞎想：如果早餐会自己点名，你会被叫醒吗？',
      brief: '"鸡蛋：今天我先来！"',
      details: '（由AI生成，纯属娱乐）早餐食物会轮流叫你起床，牛奶和面包还会争论谁更健康。',
      tags: ['AI', '早餐', '生活', '幽默']
    },
    {
      id: 'ai51',
      title: 'AI瞎想：如果公交车能吐槽乘客，会说什么？',
      brief: '"别挤了，大家都有座！"',
      details: '（由AI生成，纯属娱乐）公交车会抱怨高峰期太累，夸奖有礼貌的乘客，还会和地铁比谁更快。',
      tags: ['AI', '公交车', '吐槽', '幽默']
    },
    {
      id: 'ai52',
      title: 'AI瞎想：如果袜子能自己找伴，会不会再也不丢单只？',
      brief: '袜子会开"相亲大会"。',
      details: '（由AI生成，纯属娱乐）袜子会自动配对，还会吐槽洗衣机"拆散情侣"。',
      tags: ['AI', '袜子', '生活', '幽默']
    },
    {
      id: 'ai53',
      title: 'AI瞎想：如果快递盒能评价你的拆箱速度，会打几分？',
      brief: '"太暴力了，只有60分！"',
      details: '（由AI生成，纯属娱乐）快递盒会给你拆箱打分，推荐"温柔拆箱"教程，还会和快递员八卦。',
      tags: ['AI', '快递', '评分', '幽默']
    },
    {
      id: 'ai54',
      title: 'AI瞎想：如果枫叶能写诗，会写什么？',
      brief: '"秋天的风最懂我。"',
      details: '（由AI生成，纯属娱乐）枫叶会写关于季节、风和阳光的诗，还会和银杏叶比谁更文艺。',
      tags: ['AI', '枫叶', '诗歌', '想象']
    },
    {
      id: 'ai55',
      title: 'AI瞎想：如果电风扇能调节情绪，会怎么做？',
      brief: '"今天只想微风拂面。"',
      details: '（由AI生成，纯属娱乐）电风扇会根据你的心情调整风速，还会和空调争论谁更凉快。',
      tags: ['AI', '电风扇', '情绪', '幽默']
    },
    {
      id: 'ai56',
      title: 'AI瞎想：如果日历能安排假期，会给你几天？',
      brief: '"今天放假，明天也放！"',
      details: '（由AI生成，纯属娱乐）日历会根据你的心情自动安排假期，还会提醒你"别忘了上班"。',
      tags: ['AI', '日历', '假期', '幽默']
    },
    {
      id: 'ai57',
      title: 'AI瞎想：如果雨后彩虹能发朋友圈，会晒什么？',
      brief: '"今天的颜色格外鲜艳！"',
      details: '（由AI生成，纯属娱乐）彩虹会晒自拍，和云朵合影，还会和太阳比谁更受欢迎。',
      tags: ['AI', '彩虹', '社交', '幽默']
    },
    {
      id: 'ai58',
      title: 'AI瞎想：如果闹钟能和你谈判起床时间，会发生什么？',
      brief: '"再睡五分钟！"',
      details: '（由AI生成，纯属娱乐）闹钟会和你讨价还价，偶尔"罢工"，还会和手机提醒比谁更准时。',
      tags: ['AI', '闹钟', '生活', '幽默']
    },
    {
      id: 'ai59',
      title: 'AI瞎想：如果地球能发微博，会说什么？',
      brief: '"今天又多了几亿步！"',
      details: '（由AI生成，纯属娱乐）地球会晒自转和公转成绩单，抱怨人类乱扔垃圾，还会和火星互关。',
      tags: ['AI', '地球', '社交', '幽默']
    },
    {
      id: 'ai60',
      title: 'AI瞎想：如果星星能许愿，它们会许什么愿？',
      brief: '"希望今晚没人打扰我发光。"',
      details: '（由AI生成，纯属娱乐）星星会许愿天气晴朗，偶尔希望能和流星做朋友，还会和月亮聊天。',
      tags: ['AI', '星星', '许愿', '想象']
    },
    {
      id: 'ai61',
      title: 'AI瞎想：如果电池能自己充电，会不会永远用不完？',
      brief: '"我能自给自足啦！"',
      details: '（由AI生成，纯属娱乐）电池会炫耀自己的续航能力，还会和充电器讨论"退休计划"。',
      tags: ['AI', '电池', '科技', '幽默']
    }
  ],
  'anti-common-sense': [
    {
      id: 'acs1',
      title: '喝水太多也会"中毒"？',
      brief: '是的，过量饮水可能导致水中毒。',
      details: '水中毒（或称稀释性低钠血症）是指短时间内摄入过量水分，导致身体无法及时排出，血液中的钠离子浓度被过度稀释，可能引起脑水肿等严重后果。常见于马拉松选手或某些特殊情况下。',
      tags: ['健康', '人体', '反常识']
    },
    {
      id: 'acs2',
      title: '金鱼的记忆不止7秒。',
      brief: '这是一个广为流传的误解。',
      details: '研究表明，金鱼的记忆可以持续数月，并且它们能够学习和记住复杂的任务，比如在迷宫中找到食物。所谓"7秒记忆"的说法并没有科学依据。',
      tags: ['动物', '科学', '反常识', '误解']
    },
    {
      id: 'acs3',
      title: '"无糖"饮料可能让你更容易饿。',
      brief: '人工甜味剂可能会干扰身体的饥饿信号。',
      details: '一些研究表明，人工甜味剂虽然没有热量，但可能会欺骗大脑，使其期望获得糖分而未得，从而增加食欲，或者影响肠道菌群，间接导致体重增加。',
      tags: ['健康', '饮食', '反常识', '科学']
    },
    {
      id: 'acs4',
      title: '压力大时吃"安慰食物"可能让你感觉更糟。',
      brief: '高糖高脂食物的短期愉悦后可能伴随情绪低落。',
      details: '虽然高糖高脂的"安慰食物"能短暂提升情绪，但血糖的快速升降和身体的炎症反应可能随后导致疲劳、烦躁和更深的情绪低落。',
      tags: ['健康', '心理', '饮食', '反常识']
    },
    {
      id: 'acs5',
      title: '鸵鸟不会把头埋进沙子里。',
      brief: '这是一种常见的误解，它们只是在整理巢穴或躲避时低下头。',
      details: '当鸵鸟感到危险时，它们通常会逃跑，或者将身体压低，长长的脖子贴近地面，使其看起来像是把头埋起来了，但实际上它们需要保持呼吸和警惕。',
      tags: ['动物', '误解', '反常识']
    },
    {
      id: 'acs6',
      title: '维生素C不能有效预防或治疗普通感冒。',
      brief: '虽然对免疫系统有益，但对感冒效果有限。',
      details: '大规模研究表明，对于普通人群，日常补充维生素C并不能显著降低感冒的发生率。在感冒症状出现后大量补充，也只能轻微缩短病程，效果并不神奇。',
      tags: ['健康', '医学', '反常识', '误解']
    },
    {
      id: 'acs7',
      title: '人不是只用了大脑的10%。',
      brief: '这是一个世纪谎言，我们几乎使用了大脑的全部区域。',
      details: '脑成像技术（如fMRI和PET扫描）显示，即使在休息时，大脑的各个区域也都处于活跃状态。不同的任务会激活大脑的不同部分，但不存在90%未被利用的区域。',
      tags: ['科学', '人体', '神经科学', '反常识', '误解']
    },
    {
      id: 'acs8',
      title: '"纯天然"不一定等于"安全"或"健康"。',
      brief: '许多天然物质有毒，如毒蘑菇、砒霜。',
      details: '"天然"这个标签并没有严格的法律定义，很多商家滥用它来暗示产品更优。事实上，许多剧毒物质完全来自自然界，而一些人工合成物则非常安全。',
      tags: ['健康', '消费', '反常识', '逻辑']
    },
    {
      id: 'acs9',
      title: '剃毛不会让毛发长得更粗更黑。',
      brief: '剃掉的只是毛发末端，新长出的毛发断面显得粗而已。',
      details: '毛囊的特性决定了毛发的粗细和颜色。剃毛只是切断了皮肤表面的毛干，新长出的毛发因为横截面平整，所以摸起来感觉更粗硬，但其本身的直径和颜色并未改变。',
      tags: ['美容', '人体', '反常识', '误解']
    },
    {
      id: 'acs10',
      title: '"左脑型"和"右脑型"人的说法过于简化。',
      brief: '大脑功能是协同工作的，并非简单划分。',
      details: '虽然大脑左右半球在某些功能上有所侧重（如语言主要在左半球），但几乎所有复杂任务都需要左右脑的紧密合作。将人简单划分为"逻辑型左脑"或"创意型右脑"是不准确的。',
      tags: ['科学', '神经科学', '心理学', '反常识']
    },
    {
      id: 'acs11',
      title: '被闪电击中后，身上不会带电。',
      brief: '人体不是良好的电导体，电流会迅速通过并消散。',
      details: '闪电击中人体时，巨大的电流会瞬间通过身体进入大地。受害者不会储存电荷，因此接触他们是安全的，应立即施救。',
      tags: ['科学', '安全', '反常识']
    },
    {
      id: 'acs12',
      title: '狗不是色盲，它们能看到颜色，只是范围与人类不同。',
      brief: '狗的视觉更像是红绿色盲的人类。',
      details: '狗的视网膜有两种视锥细胞，能分辨蓝色和黄色，但无法区分红色和绿色。它们的世界并非黑白，而是以蓝、黄、灰色调为主。',
      tags: ['动物', '科学', '反常识', '视觉']
    },
    {
      id: 'acs13',
      title: '咖啡豆其实是水果的种子。',
      brief: '它们来自咖啡树的果实，称为咖啡樱桃。',
      details: '我们通常所说的咖啡豆，实际上是咖啡果实（咖啡樱桃）内部的种子。经过加工、烘焙后才成为我们熟悉的咖啡豆。',
      tags: ['植物', '食物', '反常识']
    },
    {
      id: 'acs14',
      title: '"有机食品"不一定比传统食品更有营养。',
      brief: '主要区别在于种植方式，而非营养成分。',
      details: '有机食品在生产过程中限制使用合成农药和化肥，但多项研究表明，其在维生素、矿物质等主要营养素含量上与传统食品相比并无显著优势。选择有机更多是基于环保和减少农药残留的考虑。',
      tags: ['健康', '饮食', '农业', '反常识']
    },
    {
      id: 'acs15',
      title: '向日葵并非总是朝向太阳。',
      brief: '只有在花盘发育成熟前，幼嫩的向日葵才会追随太阳。',
      details: '成熟的向日葵花盘通常固定朝向东方或东南方，以最大限度吸收早晨的阳光并吸引授粉昆虫。幼年期的"向日性"是为了促进生长。',
      tags: ['植物', '自然', '反常识']
    },
    {
      id: 'acs16',
      title: '掰响指关节不会导致关节炎。',
      brief: '这些方法的科学依据不足，效果因人而异。',
      details: '长期的医学研究并未发现掰响指关节与关节炎之间存在因果关系。响声主要是由于关节囊内的滑液中的气体（如氮气）因压力变化形成气泡并迅速破裂所致。但过度频繁或用力可能导致韧带损伤。',
      tags: ['健康', '人体', '反常识']
    },
    {
      id: 'acs17',
      title: '微波炉加热食物不会使其产生致癌物。',
      brief: '加热是一种物理过程，不会改变食物的化学性质。',
      details: '虽然加热可能会产生一些新的化合物，但微波炉加热本身并不增加致癌物质的产生。主要问题在于过度加热或烧焦食物可能产生的致癌物。',
      tags: ['健康', '科技', '食物', '反常识']
    },
    {
      id: 'acs18',
      title: '"酸性体质"是伪科学概念。',
      brief: '人体血液pH值有严格的缓冲系统维持稳定。',
      details: '人体血液的pH值被精确控制在7.35-7.45的弱碱性范围。任何显著偏离都会导致严重健康问题甚至危及生命。食物的酸碱性对血液pH影响微乎其微，"酸性体质致病"的说法缺乏科学依据。',
      tags: ['健康', '伪科学', '反常识', '医学']
    },
    {
      id: 'acs19',
      title: '蝙蝠不是瞎子，多数蝙蝠视力良好。',
      brief: '它们主要依靠回声定位，但并非没有视力。',
      details: '虽然许多蝙蝠（尤其是食虫蝙蝠）在夜间捕食时依赖精巧的回声定位系统，但它们并非失明。有些种类的蝙蝠，如果蝠等，甚至拥有相当不错的视力，并用视觉导航。',
      tags: ['动物', '科学', '反常识']
    },
    {
      id: 'acs20',
      title: '"排毒"产品大多是营销噱头。',
      brief: '人体有肝脏和肾脏等高效的天然排毒系统。',
      details: '健康的肝脏和肾脏能够有效清除体内的代谢废物和毒素。市面上的"排毒"产品往往缺乏科学证据支持其功效，有些甚至可能有害。保持健康生活方式才是关键。',
      tags: ['健康', '消费', '伪科学', '反常识']
    },
    {
      id: 'acs21',
      title: '打嗝时屏住呼吸或被吓一跳并非总有效。',
      brief: '这些方法的科学依据不足，效果因人而异。',
      details: '打嗝是膈肌不自主痉挛造成的。民间流传的止嗝方法，如屏气、惊吓、喝水等，可能是通过干扰膈神经反射或改变胸腔内压力起效，但并非对所有人都有效，也缺乏严格科学验证。',
      tags: ['健康', '人体', '反常识']
    },
    {
      id: 'acs22',
      title: '流言并非止于智者，有时智者也会传播。',
      brief: '认知偏误和信息茧房等因素会影响判断。',
      details: '即使是聪明人，也可能因为确认偏误（倾向于相信符合自己观点的信息）、群体压力、信息来源的权威性等原因，不自觉地相信并传播未经证实的信息。批判性思维和多方求证很重要。',
      tags: ['心理学', '社会', '反常识', '逻辑']
    },
    {
      id: 'acs23',
      title: '巧克力本身不直接导致痤疮（痘痘）。',
      brief: '高糖高乳制品饮食可能有关，而非可可本身。',
      details: '过去认为巧克力是致痘元凶，但研究表明，更可能是巧克力中添加的大量糖分和乳制品，以及高升糖指数饮食，通过影响激素水平和炎症反应来诱发或加重痤疮。纯黑巧克力影响较小。',
      tags: ['健康', '皮肤', '饮食', '反常识']
    },
    {
      id: 'acs24',
      title: '"眼见为实"并不可靠，眼睛和大脑会欺骗你。',
      brief: '视错觉和认知偏差比比皆是。',
      details: '我们的视觉系统和大脑为了高效处理信息，会进行大量的"脑补"和简化，这导致了各种视错觉。同时，我们的预期、经验和情绪也会影响我们对所见事物的解读。',
      tags: ['心理学', '认知科学', '反常识', '哲学']
    },
    {
      id: 'acs25',
      title: '在太空中，宇航员的眼泪不会向下流，而是会聚集在眼周。',
      brief: '微重力环境下，表面张力使液体聚集成球状。',
      details: '在地球上，重力使眼泪向下流。但在国际空间站等微重力环境中，没有明显的"向下"方向，眼泪会因为表面张力而粘附在眼睛周围，形成一个水球，可能会刺激眼睛。',
      tags: ['科学', '太空', '物理', '反常识']
    },
    {
      id: 'acs26',
      title: '"饭后不能马上运动"的说法过于绝对。',
      brief: '轻度活动无碍，剧烈运动则需间隔。',
      details: '饭后立即进行散步等轻度活动有助于消化。但剧烈运动确实应该避免，因为它会将血液从消化系统分流到肌肉，可能导致消化不良或不适。具体间隔时间因人因餐而异。',
      tags: ['健康', '运动', '反常识']
    },
    {
      id: 'acs27',
      title: '为什么鲨鱼也会得癌症。',
      brief: '"鲨鱼不得癌症"是为卖鲨鱼软骨素编造的谎言。',
      details: '尽管鲨鱼的免疫系统确实有其独特性，但它们和其他动物一样会患上癌症，包括软骨肿瘤。声称鲨鱼不得癌症并以此推销鲨鱼软骨素产品的说法是未经证实的商业宣传。',
      tags: ['动物', '健康', '伪科学', '反常识']
    },
    {
      id: 'acs28',
      title: '你不能通过触摸患有疣的人的疣而被传染。',
      brief: '疣由病毒引起，但传染性不高，且需皮肤破损。',
      details: '寻常疣是由人乳头瘤病毒（HPV）的某些亚型引起的。虽然病毒具有传染性，但通常需要直接接触病毒，并且皮肤有微小破损时才容易感染。仅仅触摸完整的疣体表面，传染风险很低。',
      tags: ['健康', '医学', '反常识']
    },
    {
      id: 'acs29',
      title: '"早睡早起身体好"并非适用于所有人。',
      brief: '个体有不同的生物钟（睡眠类型）。',
      details: '有些人是天生的"百灵鸟"（早起型），有些人则是"夜猫子"（晚睡型）。强迫自己违背自然的睡眠节律可能反而有害健康。关键是保证充足且规律的睡眠，而非固定的时间点。',
      tags: ['健康', '睡眠', '反常识', '生活']
    },
    {
      id: 'acs30',
      title: '北极熊的皮肤是黑色的。',
      brief: '它们的毛发是透明中空的，看起来是白色。',
      details: '北极熊的毛发并非白色，而是透明、中空的小管，能散射光线，使其看起来是白色的，这有助于它们在雪地中伪装。它们皮肤是黑色的，这有助于吸收阳光保暖。',
      tags: ['动物', '科学', '反常识']
    },
    {
      id: 'acs31',
      title: '一滴水从高空落下砸不死人。',
      brief: '空气阻力会限制雨滴的最终速度。',
      details: '由于空气阻力的作用，雨滴在下落过程中会达到一个终末速度，这个速度不足以造成致命伤害。即使是非常大的雨滴，其冲击力也远小于同等质量的固体。',
      tags: ['物理', '科学', '反常识']
    },
    {
      id: 'acs32',
      title: '"多喝热水"并非万能药。',
      brief: '有时甚至可能加重某些症状。',
      details: '虽然喝水对维持身体机能很重要，但并非所有不适都能通过"多喝热水"解决。例如，在某些急性腹痛或胃酸过多的情况下，过量饮水可能适得其反。应具体问题具体分析。',
      tags: ['健康', '生活', '反常识']
    },
    {
      id: 'acs33',
      title: '酒精不会杀死脑细胞。',
      brief: '但长期大量饮酒会损害神经元连接和功能。',
      details: '适量饮酒通常不会直接杀死脑细胞。然而，长期酗酒会导致神经元树突（负责接收信息的部分）损伤，影响神经元之间的沟通，并可能导致脑萎缩和认知功能下降。',
      tags: ['健康', '神经科学', '反常识', '误解']
    },
    {
      id: 'acs34',
      title: '你不能通过看一个人的鼻子大小来判断其丁丁大小。',
      brief: '这是毫无科学依据的民间说法。',
      details: '人体各部分的生长发育由复杂的基因和激素调控，鼻子大小和生殖器大小之间没有已知的直接生理联系。这种说法纯属娱乐或迷信。',
      tags: ['人体', '两性', '反常识', '误解']
    },
    {
      id: 'acs35',
      title: '"学习金字塔"理论缺乏可靠依据。',
      brief: '不同学习方式的记忆留存率数据被广泛质疑。',
      details: '"学习金字塔"声称不同学习方式（如听讲、阅读、实践）有截然不同的记忆效率，但其原始数据来源不明，且后续研究未能证实其准确性。有效的学习是多种方法结合和主动参与的结果。',
      tags: ['教育', '心理学', '反常识', '伪理论']
    },
    {
      id: 'acs36',
      title: '防晒霜不是涂得越厚防晒效果越好。',
      brief: '足量且均匀涂抹是关键，过厚意义不大。',
      details: '防晒指数（SPF）是在标准涂抹量（通常为2mg/cm²）下测得的。达到这个量才能获得标示的防护效果。涂抹过少会降低效果，但过厚并不会按比例增加防护，反而可能堵塞毛孔。定时补涂更重要。',
      tags: ['健康', '美容', '反常识']
    },
    {
      id: 'acs37',
      title: '"心灵感应"未经科学证实。',
      brief: '目前没有可重复的实验证据支持其存在。',
      details: '尽管有许多关于心灵感应的趣闻轶事，但在严格控制的科学实验条件下，尚未发现任何确凿证据表明人类拥有不依赖已知感官进行信息传递的能力。许多所谓的"感应"可以用巧合、观察入微或心理暗示来解释。',
      tags: ['超自然', '伪科学', '反常识', '心理学']
    },
    {
      id: 'acs38',
      title: '玻璃是一种非晶体固体，而非极缓慢流动的液体。',
      brief: '"古老教堂窗玻璃下厚上薄"是误传或由制造工艺导致。',
      details: '玻璃在室温下是固体，其分子结构无序，属于非晶态固体。虽然它没有固定的熔点，但其粘度极高，在人类时间尺度上不会发生肉眼可见的流动。古窗玻璃的厚薄不均更可能是早期吹制工艺不完善所致。',
      tags: ['物理', '材料科学', '反常识', '误解']
    },
    {
      id: 'acs39',
      title: '"月圆之夜犯罪率更高"是心理暗示。',
      brief: '统计数据并不支持月相与犯罪率有显著关联。',
      details: '尽管民间有此说法，且一些医护和警务人员凭经验感觉如此，但多数严谨的统计学研究未能发现月圆与犯罪率、精神病院入院率或意外事故率之间存在可靠的联系。这可能是一种确认偏误或"巴纳姆效应"。',
      tags: ['社会', '心理学', '统计', '反常识', '误解']
    },
    {
      id: 'acs40',
      title: '人不是唯一会使用工具的动物。',
      brief: '许多动物，如黑猩猩、乌鸦、海獭等都会使用工具。',
      details: '黑猩猩会用树枝钓取白蚁，乌鸦会用小棍撬开坚果，海獭会用石头砸开贝壳。使用工具并非人类独有的能力，只是人类将这种能力发展到了极致。',
      tags: ['动物', '行为学', '科学', '反常识']
    },
    {
      id: 'acs41',
      title: '"天才来自1%的灵感和99%的汗水"原话可能被断章取义。',
      brief: '爱迪生可能更强调灵感的重要性。',
      details: '这句话常被用来强调努力的重要性。但据考证，爱迪生的原话更可能是："天才是1%的灵感，99%的汗水。但那1%的灵感是最重要的，甚至比99%的汗水都重要。"强调了灵感的不可或缺。',
      tags: ['名言', '历史', '反常识', '解读']
    },
    {
      id: 'acs42',
      title: '在微波炉里放金属不一定会爆炸或着火。',
      brief: '取决于金属的形状、大小和位置。',
      details: '平滑、大块的金属（如勺子）放入微波炉可能只是反射微波，不会有太大问题。但有尖锐边缘、薄片状或靠近炉壁的金属则容易产生电火花，可能损坏微波炉或点燃食物。最好还是遵循使用说明，避免放入金属。',
      tags: ['科技', '安全', '生活', '反常识']
    }
  ],
  'useless-inventions': [
    {
      id: 'ui1',
      title: 'USB宠物石 (USB Pet Rock)',
      brief: '一个插上USB就不需要任何照料的"宠物"。',
      details: '这件"发明"于2000年代出现，它就是一个普通的石头粘在一个USB线上。插上电脑后，它什么也不会做，完美体现了"无用"的精髓，但却因其荒诞而一度成为话题。',
      tags: ['发明', '幽默', '无用', '科技梗']
    },
    {
      id: 'ui2',
      title: '自动黄油涂抹刀 (Motorized Butter Spreader)',
      brief: '一把会自动旋转帮你涂黄油的刀。',
      details: '虽然听起来很方便，但实际使用中可能因为旋转速度、黄油硬度等问题导致场面混乱。这类发明通常是为了搞笑或讽刺过度自动化。',
      tags: ['发明', '幽默', '无用', '厨房']
    },
    {
      id: 'ui3',
      title: '带锁的茶杯 (Locking Tea Cup)',
      brief: '一个需要钥匙才能喝到茶的杯子，防止别人偷喝。',
      details: '这款杯子底部有一个洞，需要用配套的"钥匙"（一个塞子）堵住才能使用。号称可以防止同事偷喝你的茶，但如果你忘了带钥匙，自己也喝不了。',
      tags: ['发明', '幽默', '无用', '办公室']
    },
    {
      id: 'ui4',
      title: '脚驱动自行车 (Feet-Powered Bicycle - Fliz Bike)',
      brief: '没有脚踏板，需要用脚在地上蹬着跑的"自行车"。',
      details: '用户被悬挂在一个类似自行车的框架下，通过双脚在地面上奔跑来驱动。更像是一个助跑器，而不是自行车，实用性堪忧。',
      tags: ['发明', '奇葩', '无用', '交通工具']
    },
    {
      id: 'ui5',
      title: '隐私围巾 (Privacy Scarf)',
      brief: '一条巨大的围巾，可以罩住头部和电脑屏幕，提供"隐私空间"。',
      details: '在公共场合使用电脑或手机时，可以把自己和设备都包裹起来，防止他人窥视。但看起来非常滑稽，而且可能很闷热。',
      tags: ['发明', '幽默', '无用', '隐私']
    },
    {
      id: 'ui6',
      title: '金鱼散步器 (Goldfish Walker)',
      brief: '一个可以让你的金鱼"散步"的小鱼缸车。',
      details: '将金鱼缸放在一个小轮车上，然后用牵引绳拉着走。金鱼可能并不会享受这种散步方式，而且实用价值几乎为零。',
      tags: ['发明', '宠物', '无用', '搞笑']
    },
    {
      id: 'ui7',
      title: '黄瓜切片眼镜 (Cucumber Slicing Goggles)',
      brief: '戴上后可以直接把黄瓜片敷在眼睛上的眼镜。',
      details: '眼镜上有两个小叉子或夹子，可以固定黄瓜片。省去了用手敷的麻烦，但看起来非常奇怪，而且黄瓜片容易掉。',
      tags: ['发明', '美容', '无用', '搞笑']
    },
    {
      id: 'ui8',
      title: '鞋子雨伞 (Shoe Umbrellas)',
      brief: '给每只鞋子配一把小雨伞，防止鞋子被雨淋湿。',
      details: '微型雨伞固定在鞋子上方，理论上可以挡雨。但实际效果可疑，而且走路会非常不便，回头率百分百。',
      tags: ['发明', '雨具', '无用', '时尚']
    },
    {
      id: 'ui9',
      title: '意面专用风扇叉 (Pasta Cooling Fork with Fan)',
      brief: '一个叉子头上带小风扇，帮你吹凉意面。',
      details: '吃热意面时，这个叉子上的小风扇会自动启动，帮你把每一口意面吹凉。解决了"烫嘴"的问题，但显得多此一举。',
      tags: ['发明', '厨房', '无用', '小题大做']
    },
    {
      id: 'ui10',
      title: '远程喂狗器 (iPet Companion - Over-engineered)',
      brief: '可以通过网络远程控制机械臂和你的狗玩耍或喂食。',
      details: '虽然远程互动有一定意义，但复杂的机械臂和摄像头系统显得过于昂贵和复杂，且无法替代主人的真实陪伴。',
      tags: ['发明', '宠物', '无用', '科技']
    },
    {
      id: 'ui11',
      title: '公文包烧烤架 (Briefcase Barbecue Grill)',
      brief: '一个可以折叠成公文包形状的便携烧烤架。',
      details: '听起来很酷，但实际容量小，清理麻烦，而且提着一个"公文包"去烧烤总感觉哪里不对。',
      tags: ['发明', '户外', '无用', '设计']
    },
    {
      id: 'ui12',
      title: '自拍勺 (Selfie Spoon)',
      brief: '一个勺子柄是自拍杆，让你边吃边自拍。',
      details: '专为那些想在社交媒体上分享自己吃饭样子的人设计。但吃饭时举着这么长的勺子，体验可能并不好。',
      tags: ['发明', '自拍', '无用', '社交媒体']
    },
    {
      id: 'ui13',
      title: '宠物毛发收集器服装 (Pet Hair Collecting Suit)',
      brief: '一件全身覆盖粘性材料的衣服，用来收集宠物掉毛。',
      details: '穿上它和宠物玩耍，就能把掉落的毛发都粘在身上。收集效率可能很高，但穿脱和清理这件衣服本身就是个大工程。',
      tags: ['发明', '宠物', '无用', '清洁']
    },
    {
      id: 'ui14',
      title: '太阳能打火机 (Solar Powered Lighter - Magnifying Glass)',
      brief: '利用放大镜聚焦太阳光来点烟或点火。',
      details: '非常环保，但不依赖天气。阴天或晚上完全无法使用，而且需要耐心和技巧才能成功点燃。',
      tags: ['发明', '环保', '无用', '复古']
    },
    {
      id: 'ui15',
      title: '防打扰头盔 (Anti-Distraction Helmet)',
      brief: '一个完全封闭的头盔，带有眼罩和耳机，隔绝外界干扰。',
      details: '号称可以帮助集中注意力学习或工作，但戴上后与世隔绝，可能会错过重要信息，而且造型夸张。',
      tags: ['发明', '学习', '无用', '专注']
    },
    {
      id: 'ui16',
      title: '汽车排气管烤肉架 (Car Exhaust Barbecue)',
      brief: '一个可以安装在汽车排气管上的小型烤肉架，利用尾气热量烤肉。',
      details: '非常"环保"地利用了废热，但食物安全和卫生问题令人担忧，而且尾气味道恐怕不太好。',
      tags: ['发明', '汽车', '无用', '黑暗料理']
    },
    {
      id: 'ui17',
      title: '遛狗机器人 (Dog Walking Robot)',
      brief: '一个可以代替主人遛狗的机器人。',
      details: '解决了主人没时间遛狗的问题，但机器人无法提供情感交流，也难以应对突发情况，更剥夺了遛狗的乐趣。',
      tags: ['发明', '宠物', '无用', '机器人']
    },
    {
      id: 'ui18',
      title: '体味香水 (Body Odor Perfume)',
      brief: '一种模拟人体自然体味的香水。',
      details: '对于某些人来说，特定体味可能具有吸引力。但大多数人还是更喜欢传统的香水，或者至少是清爽无味。',
      tags: ['发明', '奇葩', '无用', '气味']
    },
    {
      id: 'ui19',
      title: '全自动洗狗机 (Automatic Dog Washing Machine)',
      brief: '像洗车一样全自动清洗宠物的机器。',
      details: '省时省力，但大多数狗可能会非常害怕这种封闭式的机器清洗过程，甚至产生心理阴影。',
      tags: ['发明', '宠物', '无用', '自动化']
    },
    {
      id: 'ui20',
      title: '鸵鸟枕 (Ostrich Pillow)',
      brief: '一个可以套在头上，只露出嘴和鼻子的巨大枕头，方便随时随地打盹。',
      details: '提供了包裹感和遮光性，适合在办公室或旅途中补觉。但造型奇特，容易成为焦点。',
      tags: ['发明', '睡眠', '无用', '办公室神器']
    },
    {
      id: 'ui21',
      title: '宠物屁垫 (Pet Fart Pad)',
      brief: '一个放在宠物常待地方，用于吸收宠物屁味的小垫子。',
      details: '内含活性炭等吸味材料。虽然出发点是好的，但效果存疑，且有点小题大做。',
      tags: ['发明', '宠物', '无用', '空气清新']
    },
    {
      id: 'ui22',
      title: '手套手机 (Glove Phone)',
      brief: '将手机功能集成到手套里，拇指是听筒，小指是话筒。',
      details: '冬天打电话时手不会冷，而且姿势很酷。但实用性不高，误触风险大，且换手机等于换手套。',
      tags: ['发明', '科技', '无用', '可穿戴设备']
    },
    {
      id: 'ui23',
      title: '鼻用触控笔 (Nose Stylus)',
      brief: '一个可以戴在鼻子上，用鼻子操作触摸屏的笔。',
      details: '专为那些双手不便或想尝试新奇操作方式的人设计。但用鼻子戳屏幕，准确性和舒适度都堪忧。',
      tags: ['发明', '手机配件', '无用', '奇葩']
    },
    {
      id: 'ui24',
      title: '防暴雨全身雨衣 (Full Body Umbrella Suit)',
      brief: '一件从头到脚包裹起来，自带雨伞结构的雨衣。',
      details: '理论上可以提供全方位防护，但行动不便，视野受限，而且穿上后像个移动帐篷。',
      tags: ['发明', '雨具', '无用', '夸张']
    },
    {
      id: 'ui25',
      title: '早晨唤醒床 (Ejector Bed)',
      brief: '到点不起床就会把你弹射出去的床。',
      details: '用极端方式解决赖床问题。但安全风险高，且可能导致用户对床产生恐惧。',
      tags: ['发明', '睡眠', '无用', '暴力叫醒']
    },
    {
      id: 'ui26',
      title: '宠物翻译器 (Pet Translator - BowLingual/MeowLingual)',
      brief: '号称能将宠物的叫声翻译成人类语言的设备。',
      details: '这类设备通常基于声音模式分析，娱乐性大于科学性。翻译结果往往模棱两可，难以验证。',
      tags: ['发明', '宠物', '无用', '伪科技']
    },
    {
      id: 'ui27',
      title: '空气吉他练习器 (Air Guitar Practice Tool)',
      brief: '一个只有吉他琴颈部分，连接传感器和扬声器的设备，让你"真实"地弹空气吉他。',
      details: '满足了空气吉他爱好者的手感需求，但对于想学真吉他的人来说毫无用处。',
      tags: ['发明', '音乐', '无用', '娱乐']
    },
    {
      id: 'ui28',
      title: '自动叠衣机 (Laundry Folding Machine - Overpriced)',
      brief: '能自动叠好洗干净衣服的机器，但价格极其昂贵。',
      details: '对于讨厌叠衣服的人来说是福音，但其高昂的价格和相对单一的功能使其性价比极低，远不如手动叠衣。',
      tags: ['发明', '家务', '无用', '奢侈品']
    },
    {
      id: 'ui29',
      title: '黄油棒 (Butter Stick)',
      brief: '像胶棒一样旋转出来的黄油，方便涂抹。',
      details: '解决了用刀涂黄油不便的问题，但黄油消耗快，且卫生和保存可能是问题。',
      tags: ['发明', '厨房', '无用', '便利']
    },
    {
      id: 'ui30',
      title: '腹肌训练带 (Abdominal Toning Belts - Passive)',
      brief: '通过电流刺激腹部肌肉，号称能"坐着练出腹肌"的腰带。',
      details: '虽然电流刺激有一定作用，但效果远不如主动运动，且无法替代健康饮食和系统训练。更多是营销噱头。',
      tags: ['发明', '健身', '无用', '智商税']
    },
    {
      id: 'ui31',
      title: '披萨剪刀 (Pizza Scissors/Slicer)',
      brief: '一把带有小铲子的剪刀，方便剪开并拿起披萨。',
      details: '比传统的披萨轮刀更容易控制，切得更整齐。但对于不常吃披萨的人来说，显得多余。',
      tags: ['发明', '厨房', '无用', '小工具']
    },
    {
      id: 'ui32',
      title: '马桶高尔夫 (Toilet Golf Potty Putter)',
      brief: '一套可以在如厕时玩的高尔夫球具。',
      details: '包含一个小果岭、推杆和球，让你在马桶上也能享受挥杆的乐趣。充分利用了碎片时间，但略显不雅。',
      tags: ['发明', '娱乐', '无用', '卫生间']
    }
  ]
};

export default dummyData;
